const phoneNumStart09To9 = (phone: string, isIran = false): string => {
  const FormattedNumber = phone.trim().replace(/\s+/g, '');

  if (isIran && FormattedNumber.startsWith('0')) {
    return FormattedNumber.slice(1);
  }

  return FormattedNumber;
};

export default phoneNumStart09To9;
